import { Typography } from "@material-ui/core";
import { Cards, CustomIcon } from "ams-ui-reactkit"
import { CaptureSignature } from "../../atoms"
import './SignatureCard.scss'

export type SignatureCardProps = {
    title: string,
    sign?: any,
    signRef?: any,
    onBegin?: Function,
    onEnd?: Function,
    populate?: boolean,
    hideClear?: boolean,
    handleClearClick?: Function
    signHere: string,
    signDate?:string,
    hideSignHereText?:boolean
}

const SignatureCard = ({ title, sign, signRef, onBegin, onEnd, populate, hideClear, handleClearClick, signHere,signDate, hideSignHereText = false }: SignatureCardProps) => {
    return (
        <div className="signatureCardMain">
           {!hideSignHereText ? <Typography variant="overline" variantMapping={{ subtitle2: "span" }} className="singatureCardAttachedTag">
                {"SIGN HERE"}
            </Typography> :null}
            {title && <Typography variant="subtitle2" variantMapping={{ subtitle2: "div" }} className="color-grey mx-0 my-8 text-left">
                {title}
            </Typography>}
            <div className="border-b-1-light2">
                <CaptureSignature signCanvasRef={signRef} imageData={sign} onBegin={onBegin} onEnd={onEnd} populate={populate ? true : false} />
            </div>
            <div className="position-r pt-12">
                <div className="signTag">{signHere}<br />{signDate}</div>
                {!hideClear && <span className="signCancel" onClick={() => {
                    handleClearClick && handleClearClick()
                }}>
                    <CustomIcon iconName="cancel" size="small" />
                </span>}
            </div>
        </div>
    )
}

export default SignatureCard